// Only known product origins. No credentials or source-provided URLs.
export function customerDestination(source, item) {
  const ref = item?.navigation;
  if (!ref?.workspace_id || !ref.record_id || String(ref.record_id) !== String(item.id)) return null;
  const params = new URLSearchParams({ workspace: ref.workspace_id });
  if (source === 'crm') {
    params.set('lead', ref.record_id);
    params.set('view', 'customer');
    return `https://crm.autoappy.com/crm?${params}`;
  }
  if (source === 'whatsapp' && ref.phone_number_id) {
    params.set('conversation', ref.record_id);
    params.set('number', ref.phone_number_id);
    return `https://whatsapps.autoappy.com/conversation?${params}`;
  }
  return null;
}
